export default ({
    name : 'SpecialHeader'
    , data () {
        return {
        }
    }
    , created () {
        this.shopConfig = this.getDetailDataByCode('shop_config');
        return {}
    }
    , mounted () {
    }
    , computed : {
        getCustomName() {
            return this.shopConfig.custom_name;
        }
        , getHeaderBannerLink() {
            return this.shopConfig.header_banner_link;
        }
    }
    , methods : {
    }
    , updated () {
    }
})
